import { createSelector } from '@reduxjs/toolkit';

import { databaseSelector } from 'src/selectors/database';

export const databaseSensitivePropertyGroupsSelector = (
  databaseId: string | null
) =>
  createSelector(
    databaseSelector(databaseId),
    (database) => database?.sensitivePropertyGroups || {}
  );
